<template>
  <div v-if="grids">
    <component-grid
      v-for="(grid, idx) in grids"
      :key="idx"
      v-bind="gridProps(grid)"
    >
      <component-grid-item
        v-for="(comp, cIdx) in grid.components"
        :key="cIdx"
        :size="comp.size"
        :draft="comp.draft"
      >
        <component
          :is="comp.name"
          v-bind="comp.props"
        />
      </component-grid-item>
    </component-grid>
  </div>
</template>

<script>
import LinkBox from '../LinkBox/index.vue'
import Carousel from '../Carousel'

export default {
  name: 'GridComponent',
  inheritAttrs: false,
  components: {
    LinkBox,
    Carousel,
    ComponentGrid: () => import('../GridComponent/ComponentGrid/index.vue'),
    ComponentGridItem: () => import('../GridComponent/ComponentGridItem/index.vue'),
  },
  props: {
    grids: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    gridProps(grid) {
      if (grid.props) {
        return grid.props
      }
      return {}
    },
  },
}
</script>

<style lang="scss">

</style>
